<template>
  <van-skeleton title title-width="100%" :row="0" id="skeleton-header" :loading="sloading">
    <van-row id="header" class="bg-blue-linear">
      <van-col span="20" style="padding-top: 0.5rem;">
        <van-image
          width="70%"
          :src="site.logoUrl"
        />
      </van-col>
      <van-col span="4" style="text-align: right; color: white; font-size: 2rem;">
        <van-icon name="apps-o" @click="showPopup" style="margin-top: 0.3rem;" />
      </van-col>
      <!-- model content -->
      <van-popup v-model="show" position="left" style="width: 70%; height: 100%;">
        <!-- logo -->
        <van-row style="padding: 0.5rem 0.5rem; 0">
          <van-image
            width="70%"
            src="/static/img/logo-menu.png"
          />
        </van-row>
        <!-- divider -->
        <van-divider style="margin: 2px;" />
        <!-- menu -->
        <van-tree-select
          :items="menuItems"
          :main-active-index.sync="activeIndex"
          :active-id.sync="activeId"
          @click-item="onItemClick"
          @click-nav="onNavClick"
          height="90%"
        />
      </van-popup>
    </van-row>
  </van-skeleton>

</template>

<script>
const axios = require('axios')

export default {
  name: 'header',
  data () {
    return {
      sloading: true,
      show: false,
      menuItems: [
        {
          text: '首页',
          id: '0',
          num: 0
        },
        // {
        //   text: '学会概况',
        //   id: '1',
        //   children: [
        //     {
        //       text: '学会简介',
        //       id: '11'
        //     },
        //     {
        //       text: '学会领导',
        //       id: '12'
        //     },
        //     {
        //       text: '分支结构',
        //       id: '13'
        //     }
        //   ]
        // },
        // {
        //   text: '动态新闻',
        //   id: '2',
        //   children: [
        //     {
        //       text: '学会新闻',
        //       id: '21'
        //     },
        //     {
        //       text: '通知公告',
        //       id: '22'
        //     }
        //   ]
        // },
        // {
        //   text: '规章制度',
        //   id: '3'
        // },
        // {
        //   text: '学会服务',
        //   id: '4'
        // },
        // {
        //   text: '会员单位',
        //   id: '5'
        // },
      ],
      activeIndex: 0,
      activeId: 1,
      site: [{}],
      categoryList: [{}],
      categoryUrl: '/article/category/'
    }
  },
  mounted() {
    let that = this
    // 获取站点信息
    axios.get(that.global.apiUrl + '/web/site/queryAll')
      .then(function (response) {
        if (response.data.success && response.data.data.length > 0) {
          that.site = response.data.data[0]
          that.site.logoUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.logo
        }
      }
    )

    // 获取栏目
    axios.get(that.global.apiUrl + '/web/channel/listAll')
      .then(function (response) {
        if (response.data.success && response.data.data.length > 0) {
          // console.log(response.data.data)
          for(var i=0; i<response.data.data.length; i++) {
            if(response.data.data[i].num != -1) {
              if(response.data.data[i].children){
                var childrenList = []
                for(var j=0; j<response.data.data[i].children.length; j++){
                  var clist = {
                    text: response.data.data[i].children[j].name,
                    id: response.data.data[i].children[j].id,
                    num: response.data.data[i].children[j].num,
                    url: response.data.data[i].children[j].url
                  }
                  childrenList.push(clist)
                }
                var catList = {
                  text: response.data.data[i].name,
                  id: response.data.data[i].id,
                  num: response.data.data[i].num,
                  url: response.data.data[i].url,
                  children: childrenList
                }
              }else{
                var catList = {
                  text: response.data.data[i].name,
                  id: response.data.data[i].id,
                  num: response.data.data[i].num,
                  url: response.data.data[i].url
                }
              }

              that.menuItems.push(catList)
            }

          }
          // console.log(that.menuItems)
          that.categoryList = response.data.data
          // that.$nextTick(function () {

          // })
          that.sloading = false
        }
      }
    )

  },
  methods: {
    onItemClick(data) {
      // alert(data.id)
      if(data.url != "") {
        this.$router.push({path:data.url})
      }else {
        this.$router.push({path:'/article/category/'+data.id})
      }
    },
    onNavClick(index) {
      // console.log("vvvvvv")
      if(index == 0) {
        // alert("aaaa")
        // this.$router.push({ path:'/' })
        this.$router.push({ name:'index' })
      }else{
        var categoryUrl = ''
        for(var i=0; i<this.categoryList.length; i++) {
          if(index-1 == i) {
            categoryUrl = this.categoryList[i].url
          }
        }
        if(categoryUrl != '') {
          this.$router.push({path:categoryUrl})
        }
      }


      // console.log(index)
      // if(data.url != "") {
      //   this.$router.push({path:data.url})
      // }else {
      //   this.$router.push({path:'/article/category/'+data.id})
      // }
    },

    showPopup() {
      this.show = true;
    },
  }
}
</script>

<style>
#header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  padding: 0.3rem 1rem;
  box-shadow: 0 5px 10px rgb(0 0 0 / 50%);
  box-sizing: border-box;
}
.bg-blue-linear {
  /* background: linear-gradient(90deg, #09a7fb, #007bff); */
  background-image: radial-gradient(circle, #104883, #022952);
}

</style>



// WEBPACK FOOTER //
// src/view/header/header.vue